const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
        ) {
            const el = mutation.target;

            if (el.hasAttribute("open")) {
                setTimeout(() => {
                    document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
                    const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
                    window.dispatchEvent(new Event('scroll')); 
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                        productForm
                    });
                }, 300);
            }
        }
    });
});


document.querySelectorAll("quick-add-drawer").forEach((el) => {
    observer.observe(el, {
        attributes: true,
        attributeFilter: ["open"],
    });
});

const observerCart = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
        ) {
            const el = mutation.target;

            if (el.hasAttribute("open")) {
                setTimeout(() => {
                    window.dispatchEvent(new Event('scroll')); 
                }, 1000);
            }
        }
    });
});

document.querySelectorAll("cart-drawer").forEach((el) => {
    observerCart.observe(el, {
        attributes: true,
        attributeFilter: ["open"],
    });
});

document.addEventListener("click", (e) => {
    const option = e.target.closest(
        "[bss-b2b-quickview-product-form] .custom-select__option"
    );

    if (option) {
        document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('halo-cart-content')) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

  (function () {
    if (window.__bssFilterPriceFixInstalled) return;
    window.__bssFilterPriceFixInstalled = true;

    var grid = document.querySelector('#filter-results');
    if (!grid) return;

    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 300);
    });

    observer.observe(grid, { childList: true, subtree: true });
  })();